<template>
  <ValidationObserver ref="observer">
    <div>
      <component-header
        title="Agent Details"
        :hasReload="true"
        @reload-data="reloadData"
        :hasSearch="false"
        :hasback="true"
        @back-press="$router.go(-1)"
        :hasCreate="false"
      />
      <div class="card">
        <b-row>
          <b-col md="3" class="mb-4">
            <b-card
              :img-src="prevResponse[0].product_summary.images.icon"
              img-alt="Image"
              img-top
              class="mb-2"
            >
              <h5>{{ prevResponse[0].agent.fullName }}</h5>
              <p>
                <i class="fas fa-map-marker-alt"></i>
                {{ prevResponse[0].Address.City }},
                {{ prevResponse[0].Address.State }},
                {{ prevResponse[0].Address.Country }}
              </p>
              <p><i class="fas fa-star"></i> {{ prevResponse[0].avgRating }}</p>
            </b-card>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="9">
            <div class="job-type-section">
              <h5>Job Type</h5>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="Job Type"
              >
                <b-form-radio-group
                  v-model="jobType"
                  :options="jobTypeOptions"
                  class="job-type-radio"
                ></b-form-radio-group>
                <span class="validate-error custm-err">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="extra-details mt-4">
              <h5>Extra Details</h5>
              <b-form-group label="Note">
                <b-form-input
                  v-model="extraNote"
                  placeholder="Add any additional notes here..."
                ></b-form-input>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-4 justify-content-center">
          <b-col cols="12" class="text-center">
            <div v-if="isLoading" class="spinner-overlay">
              <div class="spinner"></div>
            </div>
            <b-button variant="primary" @click="showModal">Continue</b-button>
          </b-col>
        </b-row>
      </div>
      <b-modal
        ref="bookingDetailsModal"
        id="booking-details-modal"
        hide-footer
        centered
        size="lg"
        :body-class="'modal-body-custom'"
      >
        <template #modal-title>
          <h3>Booking Confirmation</h3>
        </template>

        <div class="booking-details-popup">
          <div class="agent-details">
            <img
              :src="prevResponse[0].product_summary.images.icon"
              alt="Agent Image"
              class="agent-image"
            />
            <div class="agent-info">
              <p>
                <strong>Agent Name:</strong>
                {{ prevResponse[0].agent.fullName }}
              </p>
              <p>
                <strong>Location:</strong> {{ prevResponse[0].Address.City }},
                {{ prevResponse[0].Address.State }},
                {{ prevResponse[0].Address.Country }}
              </p>
              <p>
                <strong>Rating:</strong> <i class="fas fa-star"></i>
                {{ prevResponse[0].avgRating }}
              </p>
            </div>
          </div>

          <h5>Booking Details</h5>
          <p><strong>Start Date:</strong> {{ currentDate }}</p>
          <p><strong>End Date:</strong> {{ currentDate }}</p>
          <p><strong>Working Time:</strong> {{ currentTime }}</p>
          <p><strong>Job Type:</strong> {{ jobType }}</p>
          <p><strong>Note:</strong> {{ extraNote }}</p>
        </div>
        <div class="text-center mt-4">
          <b-button variant="danger" @click="$refs.bookingDetailsModal.hide()">
            Close
          </b-button>
          <b-button variant="primary" class="ml-2" @click="finalizeBooking">
            Confirm Booking
          </b-button>
        </div>
      </b-modal>
    </div>
  </ValidationObserver>
</template>

<script>
import ComponentHeader from "@/components/componentNewHeader";
import moment from "moment";
import {
  ValidationProvider,
  ValidationObserver,
  Validator,
} from "vee-validate";

export default {
  components: {
    ComponentHeader,
    ValidationProvider,
    ValidationObserver,
    Validator,
  },
  data() {
    return {
      jobType: null,
      jobTypeOptions: [],
      extraNote: "",
      paramsData: null,
      prevResponse: [],
      currentDate: new Date().toLocaleDateString(),
      currentTime: new Date().toLocaleTimeString(),
      isLoading: false,
      bookingDetailsData: null,
    };
  },
  methods: {
    async showModal() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      this.isLoading = true;
      const listData = this.$route.params.listData;
      const payload = {
        // item: listData._id,
        item: this.prevResponse[0]?._id,
        date: moment(new Date()).format("DD/MM/YYYY"),
        checkout: {
          type: "COD",
          userEmail: listData?.authentication?.email,
          userPhone: listData?.authentication?.phone.replace(/\s/g, ""),
          customerNo: listData?.customerNo,
          useWallet: true,
        },
        custom: {
          jobType: this.jobType,
          extraNote: this.extraNote,
          startDate: new Date().toLocaleDateString(),
          endDate: new Date().toLocaleDateString(),
          startTime: new Date().toLocaleTimeString(),
          endTime: new Date().toLocaleTimeString(),
        },
        isMobile: false,
      };
      try {
        await this.$store.dispatch("onboardCustomer/checkoutAction", payload);
      } catch (error) {
        console.error("API error:", error);
      } finally {
        this.isLoading = false;
      }
      if (this.$refs.bookingDetailsModal) {
        this.$refs.bookingDetailsModal.show();
      } else {
        console.error("Modal ref is not defined.");
      }
    },
    reloadData() {
      this.bookingDetails();
    },
    async bookingDetails() {
      this.paramsData = this.$route.params.data;
      const payload = {
        catalog: this?.paramsData?.catalog,
        age: [],
        categoryName: this?.paramsData?.categoryName,
        days: this?.paramsData?.days,
        experience: [],
        provider: "66fd3e4a3ac1dda7694a4bc1",
        type: "SERVICE",
      };
      try {
        const response = await this.$store.dispatch(
          "onboardCustomer/bookingDetailsAction",
          payload
        );
        this.bookingDetailsData = response;
      } catch (error) {
        console.error("API error:", error);
      }
    },
    async finalizeBooking() {
      const customerId = this.$route.params.id;
      const providerId =
        this.prevResponse[0]?.providerId || "66fd3e4a3ac1dda7694a4bc1";

      if (!customerId) {
        console.error("Customer ID is missing.");
        return;
      }
      const listData = this.$route.params.listData;
      const payload = {
        type: "SERVICE",
        customerDetails: {
          id: customerId,
          orderAmount: 70,
          category: "CUSTOMER",
          customerName:
            listData?.name?.first + listData?.name?.last || "default_name",
          customerPhone: listData.authentication.phone || "default_phone",
          customerEmail: listData.authentication.email || "default_email",
          name: {
            first: listData?.name?.first || "First",
            last: listData?.name?.last || "Last",
          },
        },
        isSeller: true,
        providerDetails: {
          category: "DISTRIBUTOR",
          id: "65641df8c5ad7b08884e7cd4",
          name: "RR Sharma",
          email: "l30@yopmail.com",
          phone: "+16857658866",
        },
        orderDetails: {
          type: "SERVICE",
          unit: "1",
          unitType: {
            label: "1 Bed 1 Bath",
          },
          floor: "1",
          block: "1",
          leaseStart: "2024-10-08",
          leaseEnd: "2024-11-01",
          deliveryAddress: {
            address: {
              location: {
                coordinates: [
                  this.prevResponse[0]?.Lat || 22.6636967,
                  this.prevResponse[0]?.Lng || 87.7468071,
                ],
                type: "point",
              },
              isdefault: false,
              contacts: [
                {
                  _id: listData._id,
                  value: listData.authentication.phone || "default_phone",
                  contacttype: "primary_phone",
                },
                {
                  _id: listData._id,
                  value: listData.authentication.email || "default_email",
                  contactType: "PRIMARY_EMAIL",
                },
              ],
              fullName:
                listData?.name?.first + listData?.name?.last || "default_name",
              houseNumber: "DF38",
              street2: "Company",
              street1: "Area",
              zip: "721212",
              city: this.prevResponse[0]?.Address?.City || "default_city",
              state: this.prevResponse[0]?.Address?.State || "default_state",
              country:
                this.prevResponse[0]?.Address?.Country || "default_country",
              category: "Home",
            },
            loc: {
              coordinates: [
                this.prevResponse[0]?.Lat || 22.6636967,
                this.prevResponse[0]?.Lng || 87.7468071,
              ],
              type: "Point",
            },
          },
          items: [
            {
              productId: "66de7fb97f0a511360996cff",
              tenant: "66f1000a05fe0c77e56a7624",
              provider: "66b609e7ef862f7f4c38fbf9",
              providerName: "Allseller",
              name: "Sooji",
              description: "Sooji",
              imageLink:
                "https://nipigedev-storage.s3.amazonaws.com/images/seller/items/m0uj0vwv0d5jp",
              inventoryItems: [],
              qty: 1,
              unitPrice: 80,
              unitAmount: 80,
              price: 70,
              finalPrice: 70,
              priceBeforeTax: 0,
              discount: 10,
              discountAmount: 10,
              isSelfPickUp: true,
              offerCode: "",
              shipFrom: "IN",
              shipTo: "IN",
              country: "IN",
              taxes: [],
              totalTaxes: 0,
              status: "LOCKED",
              pickUpTime: "2024-09-26T09:30:00.000Z",
              delivery: {
                courier_company_id: 1,
                courier_name: "self",
                charge: 0,
                customer_bill: 0,
                etd: "",
              },
            },
          ],
        },
        custom: {
          jobType: this.bookingDetailsData[0]?.agent?.category,
          avgRating: this.bookingDetailsData[0]?.avgRating,
          extraNote: this.extraNote,
          startDate: new Date().toLocaleDateString(),
          endDate: new Date().toLocaleDateString(),
          startTime: new Date().toLocaleTimeString(),
          endTime: new Date().toLocaleTimeString(),
        },
        txData: {
          orderId: "3",
          referenceId: "",
          txStatus: "",
          txMsg: "",
          txTime: "",
          signature: "",
          PaymentServiceName: "",
        },
        createdAt: "2024-09-26T11:43:28.406Z",
        payment: {
          type: "COD",
          orderId: "3",
        },
        isNew: true,
        type: "SERVICE",
      };

      try {
        const res = await this.$store.dispatch(
          "onboardCustomer/onboardNewCustomer",
          payload
        );
        this.$router.push({
          name: "bookingSuccess",
          params: {
            orderId: res.data?.response?.orderId,
          },
        });
      } catch (error) {
        console.error("API error:", error);
      }
    },
    loadJobTypeOptions() {
      if (this.prevResponse[0] && this.prevResponse[0].variations) {
        this.jobTypeOptions = this.prevResponse[0].variations
          .filter(
            (variation) => variation.attributes && variation.attributes.JobType
          )
          .map((variation) => ({
            value: variation.attributes.JobType,
            text: variation.attributes.JobType,
          }));
      } else {
        console.error("JobType data not found in response.");
      }
    },
  },
  mounted() {
    this.bookingDetails();
    this.prevResponse = this.$route.params.req;
    this.loadJobTypeOptions();
  },
};
</script>

<style scoped>
.card {
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  border: 1px solid #eaeaea;
  margin-bottom: 20px;
}
.service-type-radio {
  display: flex;
  gap: 20px;
}
h4 {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 20px;
}
h5 {
  font-size: 1.2rem;
  font-weight: 600;
  color: #5a5a5a;
  margin-bottom: 10px;
}
.btn {
  width: auto;
  padding: 10px 20px;
}
.agent-details {
  display: flex;
  align-items: center;
  gap: 10px;
}
.agent-image {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
}
.agent-info {
  font-size: 0.9rem;
}
.booking-details-popup {
  padding: 10px;
}
.modal-body-custom {
  padding: 20px;
}
.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}

.spinner {
  border: 6px solid rgba(0, 0, 0, 0.1);
  border-left-color: #000;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
